import { createFileRoute } from '@tanstack/react-router';
import { ToolsPage } from '../../../pages/tools/ToolsPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/')({
  head: () => toolHead(''),
  component: ToolsPage,
});
